<template>
  <div>
    <b-card title="گردش کیف پول دلاری">
      <div v-if="!dataLoaded">
        <b-row>
          <b-col cols="3">
            <b-form-group label="درگاه">
              <b-skeleton type="button" width="100%" class="mb-3"></b-skeleton>
            </b-form-group>
          </b-col>
        </b-row>

        <b-skeleton-table
          :rows="10"
          :columns="7"
          :table-props="{ bordered: true, striped: true }"
        ></b-skeleton-table>
      </div>
      <div v-if="dataLoaded">
        <b-row class="mb-5">
          <b-col
            cols="12"
            md="4"
            sm="4"
            v-for="summery in loadedWalletSummery"
            :key="summery.type"
          >
            <b-card class="text-danger" :title="''">
              <b-row class="text-primary">
                <b-col cols="12" md="6" sm="6">
                  <b-form-group label="نرخ دلار (ریال):">
                    <div class="form-control">
                      {{ Number(getexchanngebyname(summery)).toLocaleString() }}
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" sm="6">
                  <b-form-group label="موجودی (دلاری):">
                    <div class="form-control">
                      {{ summery.mojudi.toLocaleString() }}
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" sm="6">
                  <b-form-group label="مبلغ در حال تسویه (دلار):">
                    <div class="form-control">
                      {{ summery.paying.toLocaleString() }}
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" sm="6">
                  <b-form-group label="مبلغ در حال تسویه (ریال):">
                    <div class="form-control">
                      {{
                        (
                          getexchanngebyname(summery) * summery.paying
                        ).toLocaleString()
                      }}
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="3">
            <b-form-group label="درگاه">
              <b-form-select
                v-model="gateway_id"
                :options="gateways"
                @change="LoadData(1)"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table
          responsive
          striped
          hover
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
          :fields="fields"
          :items="transactions"
        >
          <template v-slot:cell(created_at)="row">{{
            getDate(row.item.created_at)
          }}</template>
          <template v-slot:cell(Amount)="row">
            <span v-if="row.item.bes - row.item.bed > 0" class="text-success">{{
              row.item.bes - row.item.bed
            }}</span>
            <span v-if="row.item.bes - row.item.bed < 0" class="text-danger">{{
              row.item.bes - row.item.bed
            }}</span>
          </template>
        </b-table>
        <b-button-group v-if="page_count > 1">
          <b-button @click="LoadData(1, false)"
            ><i class="flaticon2-next"></i
          ></b-button>
          <b-button
            v-for="page in pages"
            v-bind:key="page"
            @click="LoadData(page, false)"
            :variant="page == current_page ? 'success' : 'default'"
            >{{ page }}</b-button
          >
          <b-button @click="LoadData(page_count, false)"
            ><i class="flaticon2-back"></i
          ></b-button>
        </b-button-group>
      </div>
    </b-card>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  GET_RATE_DOLLAR,
  GET_WALLET_SUMMERY,
} from "@/core/services/store/dollarRate.module";
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
export default {
  name: "walletTrans",
  data() {
    return {
      dataLoaded: false,
      gateway_id: null,
      gateways: [],
      transactions: [],
      pages: [],
      current_page: 1,
      page_count: 0,
      fields: [
        {
          key: "created_at",
          label: "تاریخ",
        },
        {
          key: "website_name",
          label: "وبسایت",
        },
        {
          key: "transaction_id",
          label: "شماره تراکنش",
        },
        {
          key: "des",
          label: "توضیحات",
          formatter(value, key, item) {
            if (item.amount < 0) {
              return "انتقال برای تسویه";
            } else {
              return (
                "واریز مبلغ " +
                Number(item.amount).toLocaleString() +
                " دلار بابت شماره تراکنش" +
                item.transaction_id
              );
            }
          },
          tdClass: (value, key, item) => {
            return item.amount > 0 ? "text-success" : "text-danger";
          },
        },
        {
          key: "cost",
          label: " مبلغ بدون احتساب کامزد (دلار)",
          // formatter(value, key, item) {
          //   return (
          //     Number(value + item.karmozd).toLocaleString() +
          //     (item.cost
          //       ? " ( " + item.cost + " " + item.money_type + " )"
          //       : "")
          //   );
          // },
          tdClass: (value, key, item) => {
            return item.cost > 0 ? "text-success" : "text-danger";
          },
        },
        {
          key: "cost-amount",
          label: " کارمزد (دلار)",
          formatter(value, key, item) {
            return Number(item.cost - item.amount).toLocaleString();
          },
        },
        {
          key: "totalsum",
          label: "موجودی (دلار) ",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "گردش کیف پول دلاری" }]);
    this.$store.dispatch(GET_RATE_DOLLAR);
    this.$store.dispatch(GET_WALLET_SUMMERY, this.$route.params.id);
    this.LoadData(1);
    this.loadMerchants();
  },
  computed: {
    loadedListExchange() {
      return this.$store.getters.loadedListExchange;
    },
    loadedWalletSummery() {
      return this.$store.getters.loadedWalletSummery;
    },
  },
  methods: {
    getexchanngebyname(summery) {
      var exchange = this.loadedListExchange.find(function (o) {
        return o.international_gateway.code.toLowerCase() == summery.type;
      });
      return exchange.value
    },
    getDate(date) {
      var d = new Date(date);
      return (
        persianDate.getDateByFormat(date) +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes()
      );
    },
    loadMerchants() {
      httpHelper.getData("paymentgateways").then((res) => {
        this.gateways = res.result
          .filter((o) => {
            return o.mdid12_money_type != 483;
          })
          .map((o) => {
            return {
              text: o.website_name,
              value: o.id,
            };
          });
      });
    },
    createPager(last_page, current_page) {
      this.pages = [];
      this.current_page = current_page;
      var startPageer = this.current_page > 5 ? this.current_page - 4 : 0;
      var endPageer = last_page > 5 ? this.current_page + 3 : last_page;
      this.page_count = last_page;
      if (this.current_page + 3 > this.page_count) {
        endPageer = this.page_count;
      }
      for (let i = startPageer; i < endPageer; i++) {
        this.pages.push(i + 1);
      }
    },
    LoadData(page) {
      this.dataLoaded = false;
      var url = "walletTransactions/" + this.$route.params.id + "?page=" + page;
      if (this.gateway_id != null) {
        url += "&gateway_id=" + this.gateway_id;
      }
      httpHelper.getData(url).then((res) => {
        this.dataLoaded = true;
        this.transactions = res.result.data;
        // this.pages = [];
        // this.current_page = res.result.current_page;
        // for (let i = 0; i < res.result.last_page; i++) {
        //   this.pages.push(i + 1);
        // }
        this.createPager(res.result.last_page, res.result.current_page);
      });
    },
  },
};
</script>
